const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-actor.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-actor")({
  beforeLoad: async context => {
    const res = await routeLoaderApiClient.actor.$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch actor");
    }
    const {
      actor
    } = await res.json();
    if (actor == null) {
      const isSigneringsportal = context.location.pathname === "/signer";
      throw redirect({
        to: "/login",
        search: {
          url: window.location.href,
          type: isSigneringsportal ? "signeringsportal" : undefined
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});